module.exports = __webpack_public_path__ + "static/media/ukp-logo-primary.a12afc67.svg";